export default "__VITE_ASSET__TcR4nbv8RW7Jccr5IGhTTg__"